module.exports = __webpack_public_path__ + "static/media/ic_config.9c975eb7.svg";